import { applyRecruitmentCampaign } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  ApplyRecruitmentCampaignServiceRequest,
  ApplyRecruitmentCampaignServiceResponse,
} from './apply-recruitment-campaign.dto';
import {
  ApplyRecruitmentCampaignServiceRequestSchema,
  ApplyRecruitmentCampaignServiceResponseSchema,
} from './apply-recruitment-campaign.dto';

export const applyRecruitmentCampaignService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(ApplyRecruitmentCampaignServiceRequestSchema),
    async (
      request: ApplyRecruitmentCampaignServiceRequest,
    ): Promise<ApplyRecruitmentCampaignServiceResponse> => {
      const apiResponse = await applyRecruitmentCampaign(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '시딩 캠페인 신청에 실패했습니다.');
      }

      return apiResponse.data;
    },
    validateServiceResponse(ApplyRecruitmentCampaignServiceResponseSchema),
  ),
);
